import axiosInstance from "../config/axios.config";
import { getCookie } from "../helpers/localStorage";

export const createDietApi = (payload) => {
  return axiosInstance.post(`/careservices/dietitems/`, payload);
};
export const uploadDietApi = (payload) => {
  return axiosInstance.post(`/careservices/dietitems/bulk-upload/`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getCookie("access_token")}`,
      Organization: `${getCookie("organisation_id")}`,
    },
  });
};
export const getDietApi = (params) => {
  return axiosInstance.get(`/careservices/dietitems/?${params}`);
};
export const updateDietApi = (diet_id, payload) => {
  return axiosInstance.patch(`/careservices/dietitems/${diet_id}/`, payload);
};
